class Controller {
  constructor(Events, Sections, $stateParams) {
    "ngInject";

    this.Events = Events;
    this.sections = Sections.routesSections;
    this.$stateParams = $stateParams;

    this.page = this.$stateParams.page;
    this.limit = this.$stateParams.limit;
    this.activeParams = this.$stateParams;

    this.addItemEvent = this.Events.getAddEvent("stations");
    this.filterEvent = this.Events.getFilterEvent("stations");
    this.paginateEvent = this.Events.getPaginateEvent("stations");
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/stations/stations.controller.js